export interface CommentItem {
  id: string;
  user: string;
  avatar: string;
  content: string;
  time: string;
  likes: number;
}

export const demoComments: CommentItem[] = [
  {
    id: "c1",
    user: "小北在努力",
    avatar:
      "https://readdy.ai/api/search-image?query=Friendly%20young%20asian%20person%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20warm%20background%2C%20clean%20simple%20profile%20photo&width=80&height=80&seq=ks-cm-01&orientation=squarish",
    content: "太实用了，跟着做了一遍真的成功了，谢谢分享！",
    time: "2小时前",
    likes: 128,
  },
  {
    id: "c2",
    user: "一只咸鱼",
    avatar:
      "https://readdy.ai/api/search-image?query=Casual%20young%20asian%20man%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20cool%20gray%20background%2C%20clean%20simple%20profile%20photo&width=80&height=80&seq=ks-cm-02&orientation=squarish",
    content: "第一次刷到就停不下来了，已经反复看了三遍。",
    time: "5小时前",
    likes: 86,
  },
  {
    id: "c3",
    user: "夏天的风",
    avatar:
      "https://readdy.ai/api/search-image?query=Warm%20young%20asian%20woman%20smiling%20portrait%2C%20soft%20natural%20light%2C%20plain%20warm%20pastel%20background%2C%20clean%20simple%20profile%20photo&width=80&height=80&seq=ks-cm-03&orientation=squarish",
    content: "画面质感太好了，请问是用什么设备拍的呀？",
    time: "1天前",
    likes: 54,
  },
  {
    id: "c4",
    user: "搬砖阿强",
    avatar:
      "https://readdy.ai/api/search-image?query=Relaxed%20young%20asian%20worker%20smiling%20portrait%2C%20soft%20studio%20light%2C%20plain%20neutral%20background%2C%20clean%20simple%20profile%20photo&width=80&height=80&seq=ks-cm-04&orientation=squarish",
    content: "评论区都是同好，收藏起来慢慢看，感谢博主！",
    time: "2天前",
    likes: 33,
  },
];